<template>
  <div>
    <div class="text-right">
      <template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="sheet = true"
              >mdi-plus</v-icon
            >
          </template>
          <span>New Card</span></v-tooltip
        >
        <v-icon medium color="error" @click="Reload()" class="pl-2"
          >mdi-refresh</v-icon
        >

        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              class="ml-4 mr-4 mb-5"
            ></v-text-field>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            No Record(s)
          </template>
        </v-data-table>
      </template>

      <v-bottom-sheet v-model="sheet" persistent>
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="py-3 text-left">
            <v-card
              flat
              max-width="500px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ mode }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon color="grey darken-2" @click="sheet = !sheet"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>

              <v-container>
                <v-row>
                      <v-col cols="12" sm="6" md="12">
                <v-select
                  outlined
                  v-model="SelCity"
                  :items="City"
                  item-text="Vendor_Name"
                  item-value="Vendor_Id"
                  label="Select State"
                  dense
                  mt-5
                  :rules="[(v) => !!v || 'State is required']"
                  required
                  return-object
                  hide-details
                ></v-select>
              </v-col>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                      label="City Name*"
                      outlined
                      required
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>

              <v-card-actions class="justify-center">
                <v-btn color="success" dark large @click="sheet = !sheet">
                  SAVE
                </v-btn>
              </v-card-actions>

              <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
            </v-card>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </div>
</template>

<script>
//import { mapMutations } from 'vuex'
import axios from "axios";
export default {
  data() {
    return {
      mode: "NEW",
      newmode: true,
      sheet: false,
      search: "",
      loadingstatus: false,
       isUploading: false,
      SelCity:"",
      City:[],
      headers: [
        {
          text: "Vendor_Id",
          align: "start",
          sortable: false,
          value: "Vendor_Id",
        },
        { text: "Vendor", value: "Vendor_Name" },
        { text: "Address", value: "Vendor_Address" },
        { text: "City", value: "Vendor_City" },
        { text: "Bank", value: "Bank_Name" },
        { text: "Ifsc", value: "Ifsc" },
        { text: "Account", value: "Account_No" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.$store.commit("setPageTitle", "City Master");
    this.Reload();
  },
  methods: {
    Reload: function () {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "getVendors", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.desserts = res.data.result;
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },
  },
};
</script>

<style>
</style>